import React, { forwardRef } from 'react'
import type { Ref } from 'react'
import clsx from 'clsx'

export interface SwitchProps {
  /**
   * Optional className
   */
  className?: string
  /**
   * Label text
   */
  label?: string
  /**
   * On switch change
   */
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void
  /**
   * Value of switch
   */
  checked?: boolean
  editBranch?: boolean
}

/**
 * Switch component
 */

function Switch(
  {
    className,
    label = 'Label',
    onChange = () => {},
    checked = false,
    editBranch = false,
  }: SwitchProps,
  ref: Ref<HTMLInputElement>,
): JSX.Element {
  const base = 'switch'
  const cn = clsx(base, className, editBranch && `${base}__editBranch`)

  return (
    <div className={cn}>
      <label className={`${base}__wrapper`} data-testid='switch-input'>
        {editBranch && <span className={`${base}__label`}>{label}</span>}
        <input
          type='checkbox'
          hidden
          ref={ref}
          onChange={onChange}
          checked={checked}
        />
        <span className={`${base}__slider`} />
      </label>
      {!editBranch && <span className={`${base}__label`}>{label}</span>}
    </div>
  )
}

export default forwardRef(Switch)
